import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { InvoiceToReceiptChanges } from "@/features/reports/invoice-to-receipt-changes";
import { Visible } from "@/features/visibility/visible";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/weryfikacja-sprzedazy/faktura-do-paragonu")({
	component: InvoiceToReceiptChangesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.faktura-do-paragonu",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>) => {
		const now = new Date();
		const year = Number(search.year ?? now.getFullYear());

		return {
			year: Number.isFinite(year) ? year : now.getFullYear(),
		};
	},
});

function InvoiceToReceiptChangesPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	const currentYear = useMemo(() => search.year, [search.year]);
	return (
		<Visible id="page.raporty.faktura-do-paragonu" label="Faktura do paragonu">
			<InvoiceToReceiptChanges
				year={currentYear}
				onYearChange={(value) =>
					navigate({
						search: (prev) => ({
							...prev,
							year: value,
						}),
					})
				}
			/>
		</Visible>
	);
}
